import firebase from 'firebase/app'

import { Creator } from './Creator'

export type DbDocUpdateFields = {
    updatedAt: firebase.firestore.Timestamp
    updatedBy: Creator
}

export type DbDocFields = DbDocUpdateFields & {
    createdAt: firebase.firestore.Timestamp
    createdBy: Creator
}

//K will need to be never if T contains any of the fields in DbDocFields
//export type DbDocData<T, K extends T & (T extends Partial<DbDocFields> ? never : any)> = K
export type DbDoc<T> = {
    data: T
    metadata: DbDocFields
    // Defined here to prevent implicit casting from WithRef to DbDoc, which will crash the app (__snap__ should never be submitted to the database)
    __snap__?: never
}

export type WithRef<T> = Omit<T, '__snap__'> & {
    __snap__: firebase.firestore.QueryDocumentSnapshot<T> | firebase.firestore.DocumentSnapshot<T>
}

export type DbDocUpdate<T> = {
    data: T
    metadata: DbDocUpdateFields
}

export function removeRef<T>(doc: WithRef<DbDoc<T>>): DbDoc<T> {
    const { __snap__, ...rest } = doc
    return rest
}
